import React, { useEffect, useState } from 'react';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from 'react-responsive-carousel';
import { translate } from '../Services/translation';

const ProductCarousel = (props) => {
    const getImagesPerSlide = () => {
        if (window.innerWidth < 600) return 1; // Mobil
        if (window.innerWidth < 1024) return 3; // Tablet
        return 5; // Desktop
    };

    const [imagesPerSlide, setImagesPerSlide] = useState(getImagesPerSlide());
    const [slideIndex, setSlideIndex] = useState(0);

    useEffect(() => {
        const handleResize = () => {
            setImagesPerSlide(getImagesPerSlide());
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const numSlides = Math.ceil(props.products.length / imagesPerSlide);

    const goToPrev = () => {
        setSlideIndex((prev) => (prev === 0 ? numSlides - 1 : prev - 1));
    };

    const goToNext = () => {
        setSlideIndex((prev) => (prev === numSlides - 1 ? 0 : prev + 1));
    };
    
    const goToIndex = (idx) => setSlideIndex(idx);

     // Slice ut rätt bilder för aktuell slide
    const start = slideIndex * imagesPerSlide;
    const end = start + imagesPerSlide;
    const visibleImages = props.products.slice(start, end);

    return (
        <div>
             <div className="carousel-top-bar">
                <button 
                    className="custom-arrow" 
                    onClick={goToPrev} 
                    aria-label="Föregående bilder">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 16 16">
                        <path fillRule="evenodd" d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0zm-3.354 8.354a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L6.707 8H10.5a.5.5 0 0 1 0 1H6.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3z" />
                    </svg>
                </button>
                <div className="custom-dots">
                    {Array.from({ length: numSlides }).map((_, idx) => (
                        <button
                        key={idx}
                        className={`custom-dot${slideIndex === idx ? ' active' : ''}`}
                        onClick={() => goToIndex(idx)}
                        aria-label={`Gå till bildgrupp ${idx + 1}`}
                        />
                    ))}
                </div>
                <button 
                    className="custom-arrow" 
                    onClick={goToNext} 
                    aria-label="Nästa bilder">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 16 16">
                        <path fillRule="evenodd" d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0zm3.354 7.646a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L9.293 8H5.5a.5.5 0 0 1 0-1h3.793L7.646 5.354a.5.5 0 1 1 .708-.708l3 3z" />
                    </svg>
                </button>
            </div>
            <Carousel 
                showArrows={false} 
                centerMode={true} 
                centerSlidePercentage={18} 
                showThumbs={false} 
                showStatus={false} 
                renderIndicator={false}
                >
                {visibleImages.map((product, index) => (
                        <div className='carousel-item' key={index}>
                            <img src={product.ImageUrl.Url} className='carousel-item--image' />
                            <h3 className='carousel-item--heading'>{product.Name}</h3>
                            <a href={product.Url} className='carousel-item--link'>
                                {translate('productcarousel.link')}
                                <svg className="carousel-item--link--icon" width="32" height="32" viewBox="0 0 33 32" xmlns="http://www.w3.org/2000/svg">
                                    <rect x="0.776611" y="0.498047" width="31" height="31" rx="15.5" stroke="black"/><path d="M15.836 8.23517L23.4516 15.488H7.77661V16.508H23.4514L15.8359 23.7609L16.5409 24.498L24.3307 17.0788C24.6277 16.7819 24.7766 16.3922 24.7766 16.001C24.7766 15.6074 24.6257 15.2123 24.3226 14.9093L16.5409 7.49805L15.836 8.23517Z" fill="black"/>
                                </svg>
                            </a>
                        </div>
                    ))}
            </Carousel>
        </div>
    );
}

export default ProductCarousel;

